export enum AciDeliverySessionType {
    LABOLOGY = 'Labology',
    SPOTLIGHT = 'Spotlight',
    FOCUS = 'Focus',
    WEEKLY_STANDUP = 'Weekly Standup',
    LEVEL_UP = 'Level Up',
}

export const ACTIVITY_GROUP_NAME_EMBEDDED_VALUE_DELIMITER = '##';
